/**
 * Adapter utility to create IconBuilder-compatible icons from cond-ui-kit's ProductIcon data
 *
 * This allows us to use cond-ui-kit icons while maintaining compatibility with
 * our existing IconBuilder interface.
 */

import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';

/**
 * Creates an IconBuilder from cond-ui-kit icon JSON data
 */
function createIconBuilderFromCondUiKit(
	iconData: {
		icon: {
			paths: Array<string>,
			width?: number,
		},
		properties: {
			prevSize: number,
		},
	},
	defaultColor: string = '#89c32e',
): IconBuilder {
	// IcoMoon font icons use 1024-unit height regardless of icon width.
	// The icon.width property indicates the design width (e.g. 896 for angle-double icons).
	// ViewBox must be "0 0 <width> 1024" so path data (centered at y=512) renders correctly.
	const viewBoxWidth = iconData.icon.width || 1024;
	const viewBoxHeight = 1024;

	return {
		icon: ({ color = defaultColor }) => {
			return (
				<g
					fillRule="evenodd"
				>
					{iconData.icon.paths.map((path, index) => (
						<path
							d={path}
							fill={color}
							key={index}
						/>
					))}
				</g>
			);
		},
		viewBoxHeight,
		viewBoxWidth,
	};
}

export default createIconBuilderFromCondUiKit;
